module.exports = __webpack_public_path__ + "img/369386786.8e24a1f4.jpg";